import React, { ReactElement } from 'react';
import Head from 'next/head';

import { getLayout } from 'components/layouts/Sidebar';
import { withAuth } from 'lib/hocs/withAuth';
import { LOCALE_PAGES, fetchTranslationFiles } from 'lib/services/page';
import CommitteeDashboard from './CommitteeDashboard';

const Committee = (): ReactElement => {
  return (
    <>
      <Head>
        <title>Committee | Huzzle</title>
        <meta name="description" content="Huzzle" />
      </Head>
      <CommitteeDashboard />
    </>
  );
};

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await fetchTranslationFiles({
        locale,
        pages: [LOCALE_PAGES.COMMON, LOCALE_PAGES.COMMITTEE],
      })),
    },
  };
}

const CommitteeWrapper = withAuth(Committee);

// @ts-ignore
CommitteeWrapper.getLayout = getLayout;

export default CommitteeWrapper;
